import SaudeService from '@/services/SaudeService'

export const saude = {
  namespaced: true,
  actions: {
    buscarEstoqueDeRemedios () {
      return SaudeService.buscarEstoqueRemedio()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarEstoqueDeRemediosPorUnidade () {
      return SaudeService.buscarEstoqueRemedioPorUnidade()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarEstoquePorRemediosPorUnidade ({ dispatch }, { cnes, idMedicamento }) {
      return SaudeService.buscarEstoquePorRemedioPorUnidade({ cnes, idMedicamento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaConsolidado () {
      return SaudeService.buscarFilaConsolidado()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaPorProcedimento ({ dispatch }, { tipoProcedimento, categoria }) {
      return SaudeService.buscarFilaPorProcedimento({ tipoProcedimento, categoria })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaPorEspecialidade () {
      return SaudeService.buscarFilaPorEspecialidade()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaDeConsultaPorEspecialidade ({ dispatch }, { tipoConsulta }) {
      return SaudeService.buscarFilaDeConsultaPorEspecialidade({ tipoConsulta })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaDeExamePorSubgrupo ({ dispatch }, { tipoProcedimento, agrupamento }) {
      return SaudeService.buscarFilaDeExamePorSubgrupo({ tipoProcedimento, agrupamento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaDeExamePorTipoProcedimentoPorRegiao ({ dispatch }, { tipoProcedimento }) {
      return SaudeService.buscarFilaDeExamePorTipoProcedimentoPorRegiao({ tipoProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaDeExamePorProcedimentoPorRegiao ({ dispatch }, { tipoProcedimento }) {
      return SaudeService.buscarFilaDeExamePorProcedimentoPorRegiao({ tipoProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaDeExamePorEspecialidadePorRegiao ({ dispatch }, { tipoProcedimento }) {
      return SaudeService.buscarFilaDeExamePorEspecialidadePorRegiao({ tipoProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaDeExameProcedimentoPorSubgrupoPorRegiao ({ dispatch }, { tipoProcedimento }) {
      return SaudeService.buscarFilaDeExameProcedimentoPorSubgrupoPorRegiao({ tipoProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaDeExameHistoricoUltimosMeses ({ dispatch }, { ultimosMeses }) {
      return SaudeService.buscarFilaDeExameHistoricoUltimosMeses({ ultimosMeses })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarFilaDeExameHistoricoRegiao ({ dispatch }, { ultimosMeses }) {
      return SaudeService.buscarFilaDeExameHistoricoRegiao({ ultimosMeses })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarMedicamentosPorFarmacia ({ dispatch }, { filtroCnes, filtroMedicamento }) {
      return SaudeService.buscarMedicamentosPorFarmacia({ filtroCnes, filtroMedicamento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    buscarUnidadesRedeMunicipalPorGrupo ({ dispatch }) {
      return SaudeService.buscarUnidadesRedeMunicipalPorGrupo()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    filaDeProcedimentoConsolidadoPorClasse ({ dispatch }, { classeProcedimento }) {
      return SaudeService.filaDeProcedimentoConsolidadoPorClasse({ classeProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    filaDeProcedimentoPorProcedimento ({ dispatch }, { classeProcedimento }) {
      return SaudeService.filaDeProcedimentoPorProcedimento({ classeProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    filaDeProcedimentoPorGrupoDeProcedimentos ({ dispatch }, { classeProcedimento }) {
      return SaudeService.filaDeProcedimentoPorGrupoDeProcedimentos({ classeProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    filaDeProcedimentoDetalhadoPorClasseDeProcedimento ({ dispatch }, { classeProcedimento }) {
      return SaudeService.filaDeProcedimentoDetalhadoPorClasseDeProcedimento({ classeProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    filaDeProcedimentoDetalhado ({ dispatch }, { classeProcedimento }) {
      return SaudeService.filaDeProcedimentoDetalhado({ classeProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

    filaDeProcedimentoPorEspecialidade ({ dispatch }, { classeProcedimento }) {
      return SaudeService.filaDeProcedimentoPorEspecialidade({ classeProcedimento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    quantitativosDeProfissionaisPorQualificador ({ dispatch }, { qualificador }) {
      return SaudeService.quantitativosDeProfissionaisPorQualificador({ qualificador })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

  },
  state: {},
  mutations: {},
}
